import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { green, grey, white } from './colors';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

const tableTokens = [
  { propertyPath: 'background', tokenName: '--semantic-bg-surface-page-container' },
  { propertyPath: 'borderColor', tokenName: '--semantic-border-default' },
  { propertyPath: 'rowHoverBackground', tokenName: '--bg-hover' },
  { propertyPath: 'rowSelectedBackground', tokenName: '--bg-active' },
] satisfies Token[];

export const tableTokenMetadata: PaletteTokenMetadata = {
  componentName: 'table',
  tokens: tableTokens,
};

export const table = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['table'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(tableTokens, tokens, xcorTokens);
  }

  // These values are pre-computed to match the previous runtime calculations:
  // - borderColor: mui's getDataTableBorderColor() — lighten/darken of the MUI divider color
  // - rowHoverBackground: blend(background.container, action.hover, 0.2)
  return mode === 'light'
    ? {
        background: white,
        borderColor: '#E0E0E0',
        rowHoverBackground: '#EDEEF4',
        rowSelectedBackground: green[150],
      }
    : {
        background: grey[900],
        borderColor: '#525252',
        rowHoverBackground: '#323542',
        rowSelectedBackground: green[700],
      };
};
